import script from "./CrudButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudButton.vue?vue&type=script&setup=true&lang=js"

import "./CrudButton.vue?vue&type=style&index=0&id=8fc7e1fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fc7e1fe"]])

export default __exports__